import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
} from "@chakra-ui/react";
import React, { memo, useMemo } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import EmployeeKPIMonthTable from "../employeeKPIMonthTable";
import { useEmployeeKPI } from "../../../hooks/useEmployeeKPI";

const titleMap = {
  consultations: "Chi tiết tư vấn",
  leads: "Chi tiết lead",
  transactions: "Chi tiết giao dịch",
  missingLeadOrConsultTransactions: "Giao dịch thiếu lịch sử Lead/Tư vấn",
};

const FormInfo = memo(({ isOpen, onClose, defaultValues }) => {
  const code = defaultValues?.code || "";
  const monthDate = defaultValues?.monthDate || null;
  const type = defaultValues?.type || "consultations";

  const { employeeKPI, isLoading, isRefetching } = useEmployeeKPI(
    code,
    monthDate,
  );

  const tableData = useMemo(() => {
    const list = employeeKPI?.[type];
    return Array.isArray(list) ? list : [];
  }, [employeeKPI, type]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"70%"}
      >
        <Box
          paddingBottom={"80px"}
          h={"86.5vh"}
          w={"100%"}
          overflowY={"auto"}
          sx={{
            "&::-webkit-scrollbar": { width: "4px" },
            "&::-webkit-scrollbar-thumb": {
              width: "4px",
              borderRadius: "50px",
              background: "var(--color-background)",
            },
          }}
        >
          <Flex
            alignItems={"center"}
            p={"25px 24px 16px 24px"}
            position={"relative"}
            borderBottom={"1px solid var(--border-input-employee)"}
          >
            <Box>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"700"}
              >
                {titleMap[type] || "Chi tiết KPI"}
              </Text>

              <Text fontSize="12px" color="#51607B" mt="4px">
                {employeeKPI?.employee?.fullName ||
                  defaultValues?.fullName ||
                  "-"}{" "}
                {employeeKPI?.employee?.code
                  ? `(${employeeKPI?.employee?.code})`
                  : code
                    ? `(${code})`
                    : ""}
              </Text>
            </Box>

            <Box
              position={"absolute"}
              top={"18px"}
              right={"18px"}
              cursor={"pointer"}
              onClick={onClose}
            >
              <Image src={IconX} />
            </Box>
          </Flex>

          <Box p={"24px"}>
            <EmployeeKPIMonthTable
              type={type}
              data={tableData}
              isLoading={isLoading}
              isRefetching={isRefetching}
            />
          </Box>

          <Box
            position={"absolute"}
            w={"100%"}
            bottom={"0"}
            bg={"var(--color-main)"}
            borderTop={"0.5px solid var(--bg-line-employee)"}
            borderRadius={"0px 0px 16px 16px"}
            h="12px"
          />
        </Box>
      </ModalContent>
    </Modal>
  );
});

export default FormInfo;
